import React, { useState } from 'react';
import "./StandarService.scss"
import imgJacket from "../../assets/photos/WomanJacket.jpg"
import imgShirt from "../../assets/photos/MenShirt.jpg"
import imgDenim from "../../assets/photos/WomanDenim.jpg"
import imgDress from "../../assets/photos/WomanDress5.jpg"
import imgOvercoat from "../../assets/photos/WomanOvercoat.jpg"
import imgTrouser from "../../assets/photos/MenTrouser.jpg"
import imgRepair from "../../assets/photos/AlterationArtRepair.jpg"
import { Helmet } from "react-helmet-async";
const servicesStandar =  [
  {
    title: "Jackets",
    options: ["Sleeves (Shorten / Lengthen)", "Close slit", "Taper Sides (In / Out)", "Shorten Jacket"],
    image: imgJacket,
  },
  {
    title: "Trousers",
    options: ["Hemming", "Waist Adjustment", "Tapering", "Crotch Fit"],
    image: imgTrouser,
  },
  {
    title: "Dresses",
    options: ["Hemming", "Taper Sides" , "Zipper" , "Adjust Straps" ],
    image: imgDress,
  },
  {
    title: "Denim",
    options: ["Regular Hem",  "Original Hem", "Waist Adjustment", "Tapering"],
    image: imgDenim,
  },
   {
    title: "Shirts",
    options: ["Shorten Sleeves", "Taper Full Sides and Sleeves", "Shorten Hem"],
    image: imgShirt,
  },
   {
    title: "Overcoats",
    options: ["Sleeves (Shorten / Lengthen)", "Shorten Coat", "Tapering"],
    image: imgOvercoat,
  },
   {
    title: "Repairs",
    options: ["Repair Seam","Crotch Patch (pants and denim)","Patch Repair","Repair Tear","Zipper Replacement", "Button Replacement", ],
    image: imgRepair,
  }];


  const StandarService = () => {
    const [selectedService, setSelectedService] = useState(servicesStandar[0]);


  return (
    <div className='StandarService'>
      <Helmet>
        <title>Standard Alterations | Hemming & Resizing | Cooper City, FL</title>
        <meta name="description" content="Professional standard alterations including hemming, resizing, and general clothing adjustments for a perfect fit. Located in Cooper City, Florida." />
        <link rel="canonical" href="https://www.alterationsbysdenka-paola.com/services/standard" />
      </Helmet>

      <h1>A glimpse of our alteration services - expert tailoring for all your needs.</h1>
    <div className="container">
    
      <div className="menu">
        {servicesStandar.map((item) => (
          <div key={item.title} className="menu-section">
            <button className="menu-title" onClick={() => setSelectedService(item)}>
              {item.title}
              <span>{selectedService ===item ? "▼" : "▶"}</span>
            </button>
            {selectedService ===item &&
             (
              <div className="submenu">
                {item.options.map((subItem) => (
                  <div key={subItem} className="submenu-item">
                    {subItem} 
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="image-section">
        <img src={selectedService.image} alt="Fashion Style" />
      </div>
    </div>
    </div>
  );
}
  

export default StandarService;